import { render, staticRenderFns } from "./ServicePrices.vue?vue&type=template&id=d6be5468&"
import script from "./ServicePrices.vue?vue&type=script&lang=js&"
export * from "./ServicePrices.vue?vue&type=script&lang=js&"
import style0 from "./ServicePrices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports